import {AbstractService} from 'services/AbstractService';

const CURRENT_PROJECT_URL = '/api/projects/';

export class ProjectSellerService extends AbstractService {
  getCurrentProject (projectId) {
    return this.client.get(`${CURRENT_PROJECT_URL}${projectId}`);
  }

  updateCurrentProject (projectId, payload) {
    return this.client.put(`${CURRENT_PROJECT_URL}${projectId}`, payload);
  }
}
